export const ROLE_USER = "ROLE_USER";
export const ROLE_USER_MAAL = "ROLE_USER_MAAL";
export const ROLE_ADMIN = "ROLE_ADMIN";

export function normalizeRole(role) {
  if (!role) return "";
  const upper = String(role).toUpperCase();
  return upper.startsWith("ROLE_") ? upper : `ROLE_${upper}`;
}

export function getUserRoles(user) {
  const roles = new Set();

  if (Array.isArray(user?.roles)) {
    user.roles.forEach((role) => roles.add(normalizeRole(role)));
  }

  if (typeof user?.role === "string") {
    roles.add(normalizeRole(user.role));
  }

  if (Array.isArray(user?.authorities)) {
    user.authorities.forEach((authority) => {
      if (typeof authority === "string") {
        roles.add(normalizeRole(authority));
      } else if (authority?.authority) {
        roles.add(normalizeRole(authority.authority));
      } else if (authority?.name) {
        roles.add(normalizeRole(authority.name));
      }
    });
  }

  return roles;
}

export function hasRole(user, role) {
  return getUserRoles(user).has(normalizeRole(role));
}

export function hasAnyRole(user, roles = []) {
  const userRoles = getUserRoles(user);
  return roles.some((role) => userRoles.has(normalizeRole(role)));
}
